
const EXPENSES = [
  {
    name: "expenseTitle",
    id: "expenseTitle",
    label: "Expense Title",
    widget: "link",
    fixed:'left'
  },
  {
    id: "amount",
    label: "Amount",
    widget: "amount"
  },
  {
    id: "costCenter",
    label: "Cost Center",
    widget: "text"
  }, {
    id:'category',
    label: "category",
    widget: "text"
  },{
    id: "expenseDate",
    label: "Expense Date",
    widget: "date",
    format : "DD-MMM-YYYY"
  },
  {
    id: "attachments",
    label: "Receipts",
    widget: "attachments"
  },
  {
    id: "comment",
    label: "Comment",
    widget: "text"
  },
  {
    id: "createdAt",
    label: "Created Date",
    widget: "date",
    format : "DD-MMM-YYYY"
  }, {
    id: "status",
    label: "Status",
    name: "status",
    widget: "status",
    width:150
  }];

const DATA=[{
  expenseTitle:'Inter net connection',
  category:'Hardware',
  costCenter:'IT',
  expenseDate:'01-01-2020',
  currency:'USD',
  amount:100,
  comment:'test',
  attachments:'test',
  createdDate:'01-01-2020',
  status:1
},{
  expenseTitle:'Inter net connection',
  category:'Hardware',
  costCenter:'IT',
  expenseDate:'01-01-2020',
  currency:'USD',
  amount:100,
  comment:'test',
  attachments:'test',
  createdDate:'01-01-2020',
  status:1
}];

export{
  EXPENSES,
  DATA
};